module.exports = __webpack_public_path__ + "static/media/Ludicolo_gaussian2.ab02d174.png";